import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './ProgressBar.st.css';
import Heading from '../../Heading';
import { ProgressBarProps } from './ProgressBar.types';

const ProgressBar = ({ dataHook, progress }: ProgressBarProps) => {
  return (
    <div data-hook={dataHook} className={classes.root}>
      <Heading size="extraTiny">{`${progress}%`}</Heading>
      <span className={classes.bar}>
        <span className={classes.value} style={{ width: progress + '%' }} />
        <span
          className={classes.leftover}
          style={{ width: 100 - progress + '%' }}
        />
      </span>
    </div>
  );
};

ProgressBar.propTypes = {
  dataHook: PropTypes.string,
  progress: PropTypes.number.isRequired,
};

export default ProgressBar;
